export default "__VITE_ASSET__F682vwE1__"